import React from 'react'
import { ArrowRight, Camera, Maximize2, Play } from 'lucide-react'
import { Button } from 'components/ui'
import useLocaleText from 'components/useLocaleText'
import styles from './styles.module.css'

const literals = {
  photoTitle: {
    key: 'tasks_execution_photo_full_view',
    fallback: { en: 'This photo opens in full view', he: 'התמונה נפתחת בתצוגה מלאה' },
  },
  videoTitle: {
    key: 'tasks_execution_video_full_view',
    fallback: { en: 'This video opens in full view', he: 'הסרטון נפתח בתצוגה מלאה' },
  },
  photoHint: {
    key: 'tasks_execution_photo_full_view_hint',
    fallback: {
      en: 'View results, upload photos and join the discussion in the subtask.',
      he: 'צפו בתוצאות, העלו תמונות והצטרפו לדיון בתת־המשימה.',
    },
  },
  videoHint: {
    key: 'tasks_execution_video_full_view_hint',
    fallback: {
      en: 'Play videos, upload media and join the discussion in the subtask.',
      he: 'צפו בסרטונים, העלו מדיה והצטרפו לדיון בתת־המשימה.',
    },
  },
  open: {
    key: 'tasks_execution_open_subtask',
    fallback: { en: 'Open Subtask', he: 'פתיחת תת־משימה' },
  },
}

interface IExecutionMediaEntryProps {
  isVideo: boolean
  disabled: boolean
  onOpen: () => void
}

export function ExecutionMediaEntry({ isVideo, disabled, onOpen }: IExecutionMediaEntryProps) {
  const t = useLocaleText(literals)

  return (
    <div className={styles.entry}>
      <div className={`${styles.illustration} ${isVideo ? styles.video : ''}`} aria-hidden="true">
        <div className={styles.media}>
          <div className={styles.toolbar}>
            <i />
            <i />
          </div>
          <div className={styles.stage}>
            {isVideo ? (
              <span className={styles.play}>
                <Play size={15} fill="currentColor" />
              </span>
            ) : (
              <Camera size={22} />
            )}
            {isVideo && (
              <span className={styles.progress}>
                <i />
              </span>
            )}
          </div>
          <div className={styles.thumbnails}>
            <i />
            <i />
          </div>
        </div>
        <div className={styles.discussion}>
          <div className={styles.message}>
            <i />
            <span>
              <i />
              <i />
            </span>
          </div>
          <div className={styles.composer} />
        </div>
        <span className={styles.expand}>
          <Maximize2 size={16} />
        </span>
      </div>
      <div className={styles.copy}>
        <h2>{isVideo ? t.videoTitle : t.photoTitle}</h2>
        <p>{isVideo ? t.videoHint : t.photoHint}</p>
      </div>
      <Button
        variant="primary"
        type="button"
        isDisabled={disabled}
        onClick={onOpen}
        endIcon={<ArrowRight className={styles.openArrow} size={16} aria-hidden="true" />}
      >
        {t.open}
      </Button>
    </div>
  )
}
